import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MmsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mms"}/>
}
